export default __webpack_public_path__ + "static/media/expressjsss.75fff9be.svg";